// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kW","tag":"kX","isRental":"kY","title":"kZ","title2":"k0","description":"k1","cta":"k2","ratingLabel":"k3","ratingLabelSmallScreen":"k4","iconInHotspotVideo":"k5"};